import type { ReportEntity } from '@data';

/** Nobody types these: they are the time the team already reported, read back per person. */
export const hoursByMember = (reports: ReportEntity[]): Record<string, number> => {
  const minutes: Record<string, number> = {};
  reports.forEach(report => {
    const membershipId = report.involvement?.membership?.id;
    if (!membershipId) return;
    minutes[membershipId] = (minutes[membershipId] ?? 0) + (report.minutes ?? 0);
  });
  return Object.fromEntries(
    // To a hundredth of an hour: time is reported in minutes, and a rate is billed by the hour.
    Object.entries(minutes).map(([membershipId, total]) => [membershipId, Math.round((total / 60) * 100) / 100]),
  );
};
